module.exports = __webpack_public_path__ + "img/climatescience-white.059a11d7.png";